import { FormElementState } from './form-element-state';
import { FormElementError } from './form-element-error';
import { FormElementValidators } from './form-element-validators';

export class FormElement {
  value: any;
  state: FormElementState = new FormElementState();
  error: FormElementError = new FormElementError();
  onValidation: any = FormElementValidators.defaultValidator;
  validationRules: any;


  isValid(formElementValidator: FormElementValidators = null): boolean {
    if (formElementValidator != null || formElementValidator === 'undefined') {
      this.onValidation = formElementValidator;
    }

    if (!this.error) {
      this.error = new FormElementError();
    }

    this.error.required = false;
    this.error.invalid = false;

    if (this.onValidation) {
      if (this.validationRules) {
        this.onValidation(this.value, this.state, this.error, this.validationRules);
      } else {
        this.onValidation(this.value, this.state, this.error);
      }

    }

    return !this.error.required && !this.error.invalid;
  }
}
